import React, {Component} from 'react';
// import getMuiTheme from 'material-ui/styles/getMuiTheme';
// import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import tableBaseTheme from '../../theme/tableBaseTheme';
// import _ from 'lodash';
import { STRIPE_KEY, COST, CURRENCY } from 'constants/stripe';
import StripeCheckout from 'react-stripe-checkout';
import {inject} from 'mobx-react';
// import HttpClient from 'services/HttpClient';
import { withRouter } from 'react-router-dom';
// const SUBSCRIPTIONS = '/api/v1/subscriptions/';
// import {
//   Table,
//   TableBody,
//   TableHeader,
//   TableHeaderColumn,
//   TableRow,
//   TableRowColumn
// } from 'material-ui/Table';



@withRouter
@inject('userStore')
@inject('alertStore')
export default class PricingSettings extends Component {
  state = {

  };


  componentWillMount = () => {
    // new HttpClient().get(SUBSCRIPTIONS).then(data => {
    //   if(data.body.data.transctions)
    //     this.setState({payments: data.body.data.transctions, active: data.body.data.active})
    // })
  };



  render() {
    return (
      <div className="pricing-wrap">
        <div className="courses-container">

          <div className="single-course">
            <div className="course-header">
              <span>COURSE:</span>
              <p>Prescription Revision Autumn 2020 Course</p>
            </div>
            <div className="course-body">
              <span>DESCRIPTION:</span>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio dolores aliquam neque totam perferendis vero possimus eligendi, voluptatem aperiam rem. Voluptatibus consequuntur doloribus voluptas! Impedit architecto, neque dolorem deserunt dolores quia. Saepe odit, temporibus quaerat assumenda amet inventore quis deleniti ut dicta aliquid veritatis quas laudantium similique aspernatur atque iure.</p>
            </div>
            <div className="course-footer">
              <div>
                <span>PRICE:</span>
                <p>€ 125</p>
              </div>
              <div>
                <StripeCheckout
                  email={this.props.userStore.user.email}
                  panelLabel="Submit payment"
                  stripeKey={STRIPE_KEY}
                  amount={COST}
                  allowRememberMe={false}
                  currency={CURRENCY}
                  // token={this.onToken}
                >
                  <button className="btn rounded blue repeat-btn">Purchase</button>
                </StripeCheckout>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/components/PricingSettings.js